/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PairingCompletionRequest { 
    /**
     * Agent ID
     */
    agent_id: string;
    /**
     * Device code
     */
    device_code: string;
    /**
     * Grant type
     */
    grant_type: string;
}

